module.exports = __webpack_public_path__ + "img/Elsstic.3f50687.svg";